import { useState, useContext, useEffect } from 'react';
import { SharedInfoContext } from './SharedInfoContextProvider';

export const useUserAPI = () => {

const [data, setData] = useState(null);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [scnflg, setScnflg] = useState(false);

const sharedInfo = useContext(SharedInfoContext);

let userapiURL = "";
// console.log("【window.location.host】" + window.location.host);
if(window.location.host === "miniapp.regigo.jp"){ //本番
	// console.log("【userapiURL】" + process.env.REACT_APP_USERAPI_PRO);
	userapiURL = process.env.REACT_APP_USERAPI_PRO;
}else { //開発
	// console.log("【userapiURL】" + process.env.REACT_APP_USERAPI_DEV);
	userapiURL = process.env.REACT_APP_USERAPI_DEV;
}

let timeout_time = process.env.REACT_APP_USERAPI_TIMEOUT;


//----------------------------------------
//ユーザー情報取得API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const userinfoAPI = async (tcode) => {
	// timeout_time = 0;
	const fetchTimeout01 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【userinfoAPI】 post");
		console.log("【userinfoAPI】 terminalCode: "+tcode);
		const jsonData01 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode":tcode
		};

		const response = await fetchTimeout01(userapiURL + '/scng/userinfo', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData01)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);
	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【userinfoAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【userinfoAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//ユーザー情報登録API
//----------------------------------------

function getMobileOperatingSystem() {
	let userAgent = navigator.userAgent || navigator.vendor || window.opera;
	if (/windows phone/i.test(userAgent)) {
		// return "Windows Phone";
		return 0;
	}
	if (/android/i.test(userAgent)) {
		// return "Android";
		return 0;
	}
	// iOSデバイスのuserAgentには"iPhone", "iPad", または"iPod"が含まれます
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		// return "iOS";
		return 1;
	}
	// return "unknown";
	return 0;
}
let dtype = getMobileOperatingSystem();

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const userregisterAPI = async () => {
	// timeout_time = 0;
	const fetchTimeout02 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【userregisterAPI】 post");
		console.log("【userregisterAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【userregisterAPI】 age: 20（固定）");
		console.log("【userregisterAPI】 sex: 1（固定）");
		console.log("【userregisterAPI】 postalCode: 1000004（固定）");
		console.log("【userregisterAPI】 deviceType: " + dtype);
		console.log("【userregisterAPI】 appType: 1（iAEONアプリ）");
		const jsonData02 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"age": 20,
			"sex": 1,
			"postalCode": "1000004",
			"deviceType": dtype,
			"appType": 1
		};

		const response = await fetchTimeout02(userapiURL + '/scng/userregister', {
			method: 'POST',
			mode: "cors",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData02)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【userregisterAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【userregisterAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//近く対象店舗リストAPI
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const gpsstorelistAPI = async (location) => {
	// timeout_time = 0;
	const fetchTimeout03 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【gpsstorelistAPI】 post");
		console.log("【gpsstorelistAPI】 location: " + location);

		const jsonData03 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"location": location
		};

		const response = await fetchTimeout03(userapiURL + '/scng/gpsstorelist', {
			method: 'POST',
			mode: "cors",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData03)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【gpsstorelistAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【gpsstorelistAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};

//----------------------------------------
//買物開始API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKで閉じる
//APIエラー：エラーを表示、OKで閉じる

const shoppingStartAPI = async (scode) => {
	// timeout_time = 0;
	const fetchTimeout04 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		// console.log("storecode: "+scode);
		// console.log("storecode: "+sharedInfo.storeCode);
		console.log("----------------------------");
		console.log("【shoppingStartAPI】 post");
		console.log("【shoppingStartAPI】 storeCode: " + scode);
		const jsonData04 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"storeCode": scode
		};

		const response = await fetchTimeout04(userapiURL + '/scng/shopping/start', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData04)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【shoppingStartAPI】request timed out > エラーを表示、OKで閉じる');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【shoppingStartAPI】Network response was not ok > エラーを表示、OKで閉じる');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//商品登録API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでウインドウ閉じる
//APIエラー：エラーを表示、OKで閉じる

//再呼び出し制限（trueで制限
let isFetching = false;

const shoppingPurchaseAPI = async (barcode) => {
	if (isFetching === true) {
		console.log("【shoppingPurchaseAPI】 再呼び出し制限中");
		setScnflg(true);
		return;
	}else{
		setScnflg(false);

		if (isFetching === false) {
		isFetching = true;
		setTimeout(() => {
			isFetching = false;
		}, 1000);

		// timeout_time = 0;
		const fetchTimeout05 = (url, options, timeout = timeout_time) => {
			return Promise.race([
				fetch(url, options),
				new Promise((_, reject) =>
					setTimeout(() => reject(new Error('Request timed out')), timeout)
				)
			]);
		};

		setData();
		setError();
		setLoading(true);
		try {
			setData();
			console.log("----------------------------");
			console.log("【shoppingPurchaseAPI】 post");
			console.log("【shoppingPurchaseAPI】 barCode: " + barcode);
			console.log("【shoppingPurchaseAPI】 token: " + sharedInfo.token);
			console.log("【shoppingPurchaseAPI】 storeCode: " + sharedInfo.storeCode);
			const jsonData05 = {
				"accessCode":"E9paYkLmhB5rnBVv2gxk",
				"terminalCode": sharedInfo.terminalCode,
				"barCode": barcode,
				"token": sharedInfo.token,
				"storeCode": sharedInfo.storeCode
			};

			// const now = new Date();
			// console.log(`現在時刻: ${now.toISOString()}`);
			// console.log(`ミリ秒までのタイムスタンプ: ${now.getTime()}`);

			const response = await fetchTimeout05(userapiURL + '/scng/shopping/mobile/purchase', {
				method: 'POST',
				mode: "cors",
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(jsonData05)
			}, timeout_time);

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const result = await response.json();
			console.log(result);
			setData(result);

		} catch (error) {
			if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス）
				console.error('【shoppingPurchaseAPI】request timed out > エラーを表示、OKでウインドウ閉じる');
				setError({ errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false });
				// setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			} else if (error.message === 'Network response was not ok') { //通信エラー
				console.error('【shoppingPurchaseAPI】Network response was not ok > エラーを表示、OKでウインドウ閉じる');
				setError({ errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false });
				// setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			} else { // その他エラー
				setError(error);
			}
		} finally {
			setLoading(false);
		}
		}
	}
};


//----------------------------------------
//商品個数変更API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでウインドウ閉じる
//APIエラー：エラーを表示、OKで閉じる

// 実行中フラグを追加
let isChangeAPIRunning = false;
let lastChangeAPITime = 0;

const changeAPI = async (token,bcode,bnum) => {
	const now = Date.now();
	if (isChangeAPIRunning || (now - lastChangeAPITime < 1000)) {
		console.log("【changeAPI】 実行中またはクールダウン中のためスルー");
		return;
	}
	isChangeAPIRunning = true;
	lastChangeAPITime = now;

	// timeout_time = 0;
	const fetchTimeout07 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【changeAPI】 post");
		console.log("【changeAPI】 barCode:" + bcode);
		console.log("【changeAPI】 count:" + bnum);
		console.log("【changeAPI】 token:" + sharedInfo.token);
		console.log("【changeAPI】 storeCode:" + sharedInfo.storeCode);
		const jsonData07 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"barCode":bcode,
			"count":bnum,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout07(userapiURL + '/scng/shopping/change', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData07)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【changeAPI】request timed out > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【changeAPI】Network response was not ok > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
		isChangeAPIRunning = false; // 実行完了時にフラグをリセット
	}
};


//----------------------------------------
//商品キャンセルAPI
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでウインドウ閉じる
//APIエラー：エラーを表示、OKで閉じる

const cancelAPI = async (token,bcode,bnum) => {
	// timeout_time = 0;
	const fetchTimeout08 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【cancelAPI】 post");
		console.log("【cancelAPI】 barCode:" + bcode);
		console.log("【cancelAPI】 count:" + bnum);
		console.log("【cancelAPI】 token:" + sharedInfo.token);
		console.log("【cancelAPI】 storeCode:" + sharedInfo.storeCode);
		const jsonData08 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"barCode":bcode,
			"count":bnum,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout08(userapiURL + '/scng/shopping/cancel', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData08)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【cancelAPI】request timed out > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【cancelAPI】Network response was not ok > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//KeyPLU商品一覧取得API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラー表示なしで、3回トライしダメならグレーアウト
//APIエラー：エラー表示なしで、3回トライしダメならグレーアウト

const keyplulistAPI = async (stoken) => {
	// timeout_time = 0;
	const fetchTimeout09 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【keyplulistAPI】 post");
		console.log("【keyplulistAPI】 terminalCode:"+sharedInfo.terminalCode);
		console.log("【keyplulistAPI】 token:"+stoken);
		console.log("【keyplulistAPI】 storeCode:"+sharedInfo.storeCode);
		const jsonData09 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": stoken,
			"storeCode":  sharedInfo.storeCode
		};

		const response = await fetchTimeout09(userapiURL + '/scng/shopping/mobile/keyplulist', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData09)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【keyplulistAPI】request timed out > エラー表示なしで、3回トライしダメならグレーアウト');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【keyplulistAPI】Network response was not ok > エラー表示なしで、3回トライしダメならグレーアウト');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//KeyPLU商品登録API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでウインドウ閉じる
//APIエラー：エラーを表示、OKで閉じる

// 実行中フラグを追加
let isChangeAPIRunning02 = false;
let lastChangeAPITime02 = 0;

const keyplupurchaseAPI = async (token,bcode,bcount) => {
	const now = Date.now();
	if (isChangeAPIRunning02 || (now - lastChangeAPITime02 < 1000)) {
		console.log("【keyplupurchaseAPI】 実行中またはクールダウン中のためスルー");
		return;
	}
	isChangeAPIRunning02 = true;
	lastChangeAPITime02 = now;

	// timeout_time = 0;
	const fetchTimeout10 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【keyplupurchaseAPI】 post");
		console.log("【keyplupurchaseAPI】 keyPluPurchaseList barCode: " + bcode);
		console.log("【keyplupurchaseAPI】 keyPluPurchaseList count: " + bcount);
		console.log("【keyplupurchaseAPI】 token: " + sharedInfo.token);
		console.log("【keyplupurchaseAPI】 storeCode: " + sharedInfo.storeCode);

		const jsonData10 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"keyPluPurchaseList": [
				{
					"barCode": bcode,
					"count": bcount
				}
			],
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout10(userapiURL + '/scng/shopping/mobile/keyplupurchase', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData10)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【changeAPI】request timed out > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【changeAPI】Network response was not ok > エラーを表示、OKでウインドウ閉じる');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
		isChangeAPIRunning02 = false; // 実行完了時にフラグをリセット
	}
};


//----------------------------------------
//売上一覧取得API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでカート画面へ戻す
//APIエラー：エラーを表示、OKでカート画面へ戻す

const saleslistAPI = async () => {
	// timeout_time = 0;
	const fetchTimeout06 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【saleslistAPI】 post");
		console.log("【saleslistAPI】 token: " + sharedInfo.token);
		console.log("【saleslistAPI】 storeCode: " + sharedInfo.storeCode);

		const jsonData06 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout06(userapiURL + '/scng/shopping/mobile/saleslist', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData06)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【saleslistAPI】request timed out');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			// props.setPage("error_35");
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【saleslistAPI】Network response was not ok');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
            setError(error);
        }
	} finally {
		setLoading(false);
	}

};


//----------------------------------------
//決済予約API（代表レジ
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラー35画面へ、OKでスタートへ戻す
//APIエラー：エラーを表示、OKでカート画面へ戻す
//APIエラー32：エラー32画面へ、OKでスタートへ戻す

//再呼び出し制限（trueで制限
let isFetching02 = false;

const payreserveAPI = async (qrcode,otbnum) => {
	if (isFetching02 === true) {
		console.log("【payreserveAPI】 再呼び出し制限中");
		setScnflg(true);
		return;
	}else{
		setScnflg(false);

		if (isFetching02 === false) {
		isFetching02 = true;
		setTimeout(() => {
			isFetching02 = false;
		}, 1000);

		// timeout_time = 0;
		const fetchTimeout11 = (url, options, timeout = timeout_time) => {
			return Promise.race([
				fetch(url, options),
				new Promise((_, reject) =>
					setTimeout(() => reject(new Error('Request timed out')), timeout)
				)
			]);
		};

		setData();
		setError();
		setLoading(true);
		try {
			console.log("----------------------------");
			console.log("【payreserveAPI】 post");
			console.log("【payreserveAPI】 terminalCode: "+sharedInfo.terminalCode);
			console.log("【payreserveAPI】 registerNumber: "+qrcode);
			console.log("【payreserveAPI】 language: Japanese");
			console.log("【payreserveAPI】 mitigationTaxFlag: 0");
			console.log("【payreserveAPI】 token: "+sharedInfo.token);
			console.log("【payreserveAPI】 storeCode: "+sharedInfo.storeCode);
			// console.log("【payreserveAPI】 otbCode: "+sharedInfo.otbCode);
			console.log("【payreserveAPI】 otbCode: "+otbnum);

			const jsonData11 = {
				"accessCode":"E9paYkLmhB5rnBVv2gxk",
				"terminalCode": sharedInfo.terminalCode,
				"registerNumber":qrcode,
				"language":"Japanese",
				"mitigationTaxFlag":"0",
				"token": sharedInfo.token,
				"storeCode": sharedInfo.storeCode,
				"otbCode": otbnum
			};

			const response = await fetchTimeout11(userapiURL + '/scng/shopping/payreserve', {
				method: 'POST',
				mode: "cors",
				headers: {
				'Content-Type': 'application/json'
				},
				body: JSON.stringify(jsonData11)
			}, timeout_time);

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const result = await response.json();
			console.log(result);
			setData(result);

		}catch (error) {
			if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
				console.error('【payreserveAPI】request timed out > エラー35画面へ、OKでスタートへ戻す');
				setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
				// setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			}else if (error.message === 'Network response was not ok') { //通信エラー
				console.error('【payreserveAPI】Network response was not ok > エラー35画面へ、OKでスタートへ戻す');
				setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
				// setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			} else { // その他エラー
				setError(error);
			}
		} finally {
			setLoading(false);
		}
		}
	}
};


//----------------------------------------
//決済API（専用レジ（個別レジ）・有人レジ
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラー35画面へ、OKでスタートへ戻す
//APIエラー：エラーを表示、OKでカート画面へ戻す
//APIエラー32：エラー32画面へ、OKでスタートへ戻す

//再呼び出し制限（trueで制限
let isFetching03 = false;

const payAPI = async (reginum,otbnum) => {
	if (isFetching03 === true) {
		console.log("【payAPI】 再呼び出し制限中");
		setScnflg(true);
		return;
	}else{
		setScnflg(false);

		if (isFetching03 === false) {
		isFetching03 = true;
		setTimeout(() => {
			isFetching03 = false;
		}, 1000);

		// timeout_time = 0;
		const fetchTimeout14 = (url, options, timeout = timeout_time) => {
			return Promise.race([
				fetch(url, options),
				new Promise((_, reject) =>
					setTimeout(() => reject(new Error('Request timed out')), timeout)
				)
			]);
		};

		setData();
		setError();
		setLoading(true);

		try {
			console.log("----------------------------");
			console.log("【payAPI】 post");
			console.log("【payAPI】 terminalCode: "+sharedInfo.terminalCode);
			console.log("【payAPI】 language: Japanese");
			console.log("【payAPI】 mitigationTaxFlag: 0");
			console.log("【payAPI】 token: "+sharedInfo.token);
			console.log("【payAPI】 storeCode: "+sharedInfo.storeCode);
			console.log("【payAPI】 registerNumber: "+reginum);
			// console.log("【payAPI】 otbCode: "+sharedInfo.otbCode);
			console.log("【payAPI】 otbCode: "+otbnum);

			const jsonData14 = {
				"accessCode":"E9paYkLmhB5rnBVv2gxk",
				"terminalCode": sharedInfo.terminalCode,
				"language": "Japanese",
				"mitigationTaxFlag": "0",
				"token": sharedInfo.token,
				"storeCode": sharedInfo.storeCode,
				"registerNumber": reginum,
				"otbCode": otbnum
			};

			const response = await fetchTimeout14(userapiURL + '/scng/shopping/pay', {
				method: 'POST',
				mode: "cors",
				headers: {
				'Content-Type': 'application/json'
				},
				body: JSON.stringify(jsonData14)
			}, timeout_time);

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const result = await response.json();
			console.log(result);
			setData(result);

		}catch (error) {
			if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
				console.error('【payAPI】request timed out > エラー35画面へ、OKでスタートへ戻す');
				setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
				// setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			}else if (error.message === 'Network response was not ok') { //通信エラー
				console.error('【payAPI】Network response was not ok > エラー35画面へ、OKでスタートへ戻す');
				setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
				// setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
			} else { // その他エラー
				setError(error);
			}
		} finally {
			setLoading(false);
		}
		}
	}
};


//----------------------------------------
//精算確認API
//----------------------------------------

//通信エラー・タイムアウト時の対応：３回トライでダメならエラー35画面へ、OKでスタートへ戻す
//APIエラー：エラーを表示、OKでカート画面へ戻す
//APIエラー32：エラー32画面へ、OKでスタートへ戻す

const settlecheckAPI = async (transaction) => {
	// timeout_time = 0;
	const fetchTimeout13 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);

	try {
		console.log("----------------------------");
		console.log("【settlecheckAPI】 post");
		console.log("【settlecheckAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【settlecheckAPI】 transactionno: "+transaction);
		console.log("【settlecheckAPI】 token: "+sharedInfo.token);
		console.log("【settlecheckAPI】 storeCode: "+sharedInfo.storeCode);
		console.log("【settlecheckAPI】 registerNumber: "+sharedInfo.registerNumber);
		// console.log("【settlecheckAPI】 registerNumber: 770000082900008730000009");

		const jsonData13 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"transactionno": transaction,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode,
			"registerNumber": sharedInfo.registerNumber
		};

		const response = await fetchTimeout13(userapiURL + '/scng/shopping/settlecheck', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData13)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

    } catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【settlecheckAPI】request timed out > ３回トライでダメならエラー35画面へ、OKでスタートへ戻す');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: Object, isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【settlecheckAPI】Network response was not ok > ３回トライでダメならエラー35画面へ、OKでスタートへ戻す');
            setError({errorCode: "35", errorMessage: "通信エラー", data: Object, isSuccess: false});
		} else { // その他エラー
            setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//くじ引きAPI
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKで支払完了へ戻す
//APIエラー：エラーを表示、OKで支払完了へ戻す

const lotteryAPI = async (transaction) => {
	// timeout_time = 0;
	const fetchTimeout15 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【lotteryAPI】 post");
		console.log("【lotteryAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【lotteryAPI】 token: "+sharedInfo.token);
		console.log("【lotteryAPI】 storeCode: "+sharedInfo.storeCode);
		console.log("【lotteryAPI】 transactionno: "+transaction);

		const jsonData15 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode,
			"transactionno": transaction
		};

		const response = await fetchTimeout15(userapiURL + '/scng/shopping/lottery', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData15)
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【lotteryAPI】request timed out > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【lotteryAPI】Network response was not ok > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//くじ引き履歴API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKで支払完了へ戻す
//APIエラー：エラーを表示、OKで支払完了へ戻す

const lotteryhistoryAPI = async () => {
	// timeout_time = 0;
	const fetchTimeout16 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【lotteryhistoryAPI】 post");
		console.log("【lotteryhistoryAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【lotteryhistoryAPI】 token: "+sharedInfo.token);
		console.log("【lotteryhistoryAPI】 storeCode: "+sharedInfo.storeCode);

		const jsonData16 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout16(userapiURL + '/scng/shopping/lotteryhistory', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData16)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【lotteryhistoryAPI】request timed out > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【lotteryhistoryAPI】Network response was not ok > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//景品受取API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでウインドウ閉じる
//APIエラー：エラーを表示、OKで閉じる

const lotteryreceiptAPI = async (transaction,number) => {
	// timeout_time = 0;
	const fetchTimeout17 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【lotteryreceiptAPI】 post");
		console.log("【lotteryreceiptAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【lotteryreceiptAPI】 token: "+sharedInfo.token);
		console.log("【lotteryreceiptAPI】 transactionno: "+transaction);
		console.log("【lotteryreceiptAPI】 number: "+number);
		console.log("【lotteryreceiptAPI】 storeCode: "+sharedInfo.storeCode);

		const jsonData17 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": sharedInfo.token,
			"transactionno": transaction,
			"number": number,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout17(userapiURL + '/scng/shopping/lotteryreceipt', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData17)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【lotteryreceiptAPI】request timed out > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【lotteryreceiptAPI】Network response was not ok > 精算確認APIへ自動遷移');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//買物中止API
//----------------------------------------

//通信エラー・タイムアウト時の対応：なにもしない
//APIエラー：なにもしない

const stopAPI = async () => {
	// timeout_time = 0;
	const fetchTimeout18 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【stopAPI】 post");
		console.log("【stopAPI】 terminalCode: "+sharedInfo.terminalCode);
		console.log("【stopAPI】 token: "+sharedInfo.token);
		console.log("【stopAPI】 storeCode: "+sharedInfo.storeCode);

		const jsonData18 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout18(userapiURL + '/scng/shopping/stop', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData18)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【stopAPI】request timed out > なにもしない');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【stopAPI】Network response was not ok > なにもしない');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};

//----------------------------------------
//取引復旧API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKで閉じる
//APIエラー：エラーを表示、OKで閉じる

const recoveryAPI = async (transaction,scode) => {
	// timeout_time = 0;
	const fetchTimeout19 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【recoveryAPI】 post");
		console.log("【recoveryAPI】 transactionno: " + transaction);
		console.log("【recoveryAPI】 storeCode: " + scode);
		const jsonData19 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"transactionno": transaction,
			"storeCode": scode
		};

		const response = await fetchTimeout19(userapiURL + '/scng/shopping/recovery', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData19)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【shoppingStartAPI】request timed out > エラーを表示、OKで閉じる');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【shoppingStartAPI】Network response was not ok > エラーを表示、OKで閉じる');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//ミニアプリ用近くの店舗API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const miniappgpsstorelistAPI = async (location) => {
	// timeout_time = 0;
	const fetchTimeout20 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【miniappgpsstorelistAPI】 post");
		console.log("【miniappgpsstorelistAPI】 location: " + location);

		const jsonData20 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"location": location
		};

		const response = await fetchTimeout20(userapiURL + '/scng/miniappgpsstorelist', {
			method: 'POST',
			mode: "cors",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData20)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【gpsstorelistAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【gpsstorelistAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//店舗チェックインAPI
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const storecheckinAPI = async (location,scode) => {
	// timeout_time = 0;
	const fetchTimeout21 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【storecheckinAPI】 post");
		console.log("【storecheckinAPI】 location: " + location);
		console.log("【storecheckinAPI】 storeCode: " + scode);

		const jsonData21 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"location": location,
			"storeCode": scode
		};

		const response = await fetchTimeout21(userapiURL + '/scng/storecheckin', {
			method: 'POST',
			mode: "cors",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData21)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【gpsstorelistAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【gpsstorelistAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//店舗情報取得API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const storelistAPI = async (location,scode) => {
	// timeout_time = 0;
	const fetchTimeout22 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【storelistAPI】 post");
		console.log("【storelistAPI】 location: " + location);
		console.log("【storelistAPI】 storeList: " + scode);

		const jsonData22 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"location": location,
			"storeList": scode
		};

		const response = await fetchTimeout22(userapiURL + '/scng/storelist', {
			method: 'POST',
			mode: "cors",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData22)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【gpsstorelistAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【gpsstorelistAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//せき止めチェック結果取得API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでgetdammingcheckresultAPIを再トライ
//APIエラー：エラーを表示、OKでgetdammingcheckresultAPIを再トライ
//エラー26・27 トークン不正、トークン有効期限切れはスタート画面へ

const getdammingcheckresultAPI = async (transaction) => {
	// timeout_time = 0;
	const fetchTimeout24 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【getdammingcheckresultAPI】 post");
		console.log("【getdammingcheckresultAPI】 transactionno: " + transaction);
		console.log("【getdammingcheckresultAPI】 token: " + sharedInfo.token);
		console.log("【getdammingcheckresultAPI】 storeCode: " + sharedInfo.storeCode);
		const jsonData24 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"transactionno": transaction,
			"token": sharedInfo.token,
			"storeCode": sharedInfo.storeCode
		};

		const response = await fetchTimeout24(userapiURL + '/scng/shopping/getdammingcheckresult', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData24)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【getdammingcheckresultAPI】request timed out > エラーを表示、OKでgetdammingcheckresultAPIを再トライ');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【getdammingcheckresultAPI】Network response was not ok > エラーを表示、OKでgetdammingcheckresultAPIを再トライ');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//端末番号発行API
//----------------------------------------

//通信エラー・タイムアウト時の対応：エラーを表示、OKでリロード
//APIエラー：エラーを表示、OKで閉じる

const getterminalnumberAPI = async () => {
	// timeout_time = 0;
	const fetchTimeout23 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【getterminalnumberAPI】 post");
		console.log("【getterminalnumberAPI】 appType: 1（iAEONアプリ）");
		const jsonData23 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"appType": 1
		};

		const response = await fetchTimeout23(userapiURL + '/scng/shopping/getterminalnumber', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData23)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		console.log(result);
		setData(result);
	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【getterminalnumberAPI】request timed out > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "タイムアウト（ノーレスポンス）", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【getterminalnumberAPI】Network response was not ok > エラーを表示、OKでリロード');
            setError({errorCode: "35", errorMessage: "通信エラー", data: [true, ``, process.env.REACT_APP_ERROR_MESSAGE_35], isSuccess: false});
            // setError({errorCode: "35", errorMessage: "通信エラー", data: [true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`], isSuccess: false});
		} else { // その他エラー
			setError(error);
        }
	} finally {
		setLoading(false);
	}
};


//----------------------------------------
//ログアップロードAPI
//----------------------------------------

//通信エラー・タイムアウト時の対応：対応なし
//APIエラー：対応なし

const loguploadAPI = async (transaction,log) => {
	// timeout_time = 0;
	const fetchTimeout25 = (url, options, timeout = timeout_time) => {
		return Promise.race([
			fetch(url, options),
			new Promise((_, reject) =>
				setTimeout(() => reject(new Error('Request timed out')), timeout)
			)
		]);
	};

	setData();
	setError();
	setLoading(true);
	try {
		console.log("----------------------------");
		console.log("【loguploadAPI】 post");
		console.log("【loguploadAPI】 transactionno: " + transaction);
		console.log("【loguploadAPI】 storeCode: " + sharedInfo.storeCode);
		console.log("【loguploadAPI】 log: " + log);
		const jsonData25 = {
			"accessCode":"E9paYkLmhB5rnBVv2gxk",
			"terminalCode": sharedInfo.terminalCode,
			"transactionno": transaction,
			"storeCode": sharedInfo.storeCode,
			"log": log
		};

		const response = await fetchTimeout25(userapiURL + '/scng/shopping/logupload', {
			method: 'POST',
			mode: "cors",
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(jsonData25)
        }, timeout_time);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const result = await response.json();
		// console.log(result);
		setData(result);

	}catch (error) {
        if (error.message === 'Request timed out') { //タイムアウト（ノーレスポンス
            console.error('【loguploadAPI】request timed out > 対応なし');
        }else if (error.message === 'Network response was not ok') { //通信エラー
            console.error('【loguploadAPI】Network response was not ok > 対応なし');
		} else { // その他エラー
			// setError(error);
        }
	} finally {
		setLoading(false);
	}
};


return {
data,
loading,
error,
userinfoAPI,
userregisterAPI,
gpsstorelistAPI,
shoppingStartAPI,
shoppingPurchaseAPI,
saleslistAPI,
changeAPI,
cancelAPI,
keyplulistAPI,
keyplupurchaseAPI,
payreserveAPI,
settlecheckAPI,
payAPI,
lotteryAPI,
lotteryhistoryAPI,
lotteryreceiptAPI,
stopAPI,
recoveryAPI,
miniappgpsstorelistAPI,
storecheckinAPI,
storelistAPI,
getdammingcheckresultAPI,
getterminalnumberAPI,
loguploadAPI
};

};
